import {
  Button,
  CheckIcon,
  CloseIcon,
  InputNumber,
  Label,
} from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { useState } from 'react'
import styles from './massive-edit.module.css'
import { TransportCompanyRouteItemProps } from './massive-edit.type'

export const MassiveEdit = ({
  onConfirm,
  onCancel,
}: TransportCompanyRouteItemProps) => {
  const { t } = useTranslation('screenLogistic')

  const [values, setValues] = useState<{
    insurancePrice?: number | string
    crossDockingPrice?: number | string
  }>({
    insurancePrice: undefined,
    crossDockingPrice: undefined,
  })

  const onHandleCancel = () => {
    setValues({
      insurancePrice: undefined,
      crossDockingPrice: undefined,
    })
    onCancel()
  }

  return (
    <div>
      <div className={styles['route-item']}>
        <div>
          <Label>{t('vehiclePricesFormInsurancePriceLabel')}</Label>
          <div className={styles['number-and-add-box']}>
            <InputNumber
              placeholder={'USD 0.00'}
              decimalPrecision={2}
              prefix={'USD '}
              stepSize={1}
              showIcons
              onChange={(value) =>
                setValues({ ...values, insurancePrice: value })
              }
              value={values?.insurancePrice}
            />
          </div>
        </div>
        <div>
          <Label>{t('vehiclePricesFormCrossDockingPriceLabel')}</Label>
          <div className={styles['number-and-add-box']}>
            <InputNumber
              placeholder={'USD 0.00'}
              decimalPrecision={2}
              prefix={'USD '}
              stepSize={1}
              showIcons
              onChange={(value) =>
                setValues({ ...values, crossDockingPrice: value })
              }
              value={values?.crossDockingPrice}
            />
          </div>
        </div>
      </div>
      <div className={styles['route-item-buttons']}>
        <Button
          variant="primary"
          model="square"
          className={styles['route-item-button']}
          onClick={() => onConfirm(values)}
        >
          <CheckIcon />
        </Button>
        <Button
          variant="danger"
          model="square"
          className={styles['route-item-button']}
          onClick={onHandleCancel}
        >
          <CloseIcon />
        </Button>
      </div>
    </div>
  )
}
